import {
    Box,
    Button,
    Divider,
    Grid,
    List,
    ListItem,
    ListItemText,
    Typography,
} from '@mui/material'
import styles from '../paymentDialog.style'
import { useWatch } from 'react-hook-form'
import usePaymentRedeemPoint from './usePaymentRedeemPoint'
import OWInput from 'components/OWForm/OWInput'
import MonetaryFormat from 'components/MonetaryFormat/MonetaryFormat'
import {
    CustomerLookupContract,
    LoyaltyRedeemPointRuleSettingContract,
    OrderLookupContract,
} from 'models'
import React from 'react'
import CalculatePanel from '../../CalculationInput/CalculatePanel'
import { useAppSelector } from 'store/useStoreHook'

function PaymentRedeemPoint({
    pointRedemptionSetting,
    onSetShowRedeemPointForm,
    orderDetail,
    onRedeemSubmit,
    customer,
}: {
    pointRedemptionSetting: LoyaltyRedeemPointRuleSettingContract | undefined
    onSetShowRedeemPointForm: (selected: boolean) => void
    onSetTenderedAmount?: LoyaltyRedeemPointRuleSettingContract
    orderDetail?: OrderLookupContract
    onRedeemSubmit: (
        pointToRedeem: number,
        discount: number,
        newTotalDue: number,
    ) => void
    popupSelectCustomerId?: string
    customer: CustomerLookupContract
}) {
    const {
        form,
        customerPointBalance,
        onChangeRedeemPoint,
        newTotal,
        maxPointCanUsed,
    } = usePaymentRedeemPoint({
        pointRedemptionSetting,
        orderDetail,
        customer,
    })

    const isLoyaltyModuleEnabled = useAppSelector(
        (state) => state.operation.data.loyalty,
    )

    const { control, handleSubmit } = form
    const [discount] = useWatch({
        control,
        name: ['discount'],
    })

    return (
        <React.Fragment>
            <Grid container spacing={1}>
                <Grid
                    item
                    xs={12}
                    md={7}
                    lg={8}
                    height={(x) => `calc(75svh - ${x.spacing(1)})`}
                >
                    <CalculatePanel
                        quickButtons={[maxPointCanUsed]}
                        isNotMoneyValue
                        isRedeemPointMode={true}
                        initialValue={maxPointCanUsed}
                        onChange={onChangeRedeemPoint}
                        useRedeemPointButton={isLoyaltyModuleEnabled}
                        onClickRedeemPoint={() =>
                            onSetShowRedeemPointForm(false)
                        }
                        disabledRedeemPoint={false}
                        minValue={0}
                    />
                </Grid>
                <Grid
                    item
                    xs={12}
                    md={5}
                    lg={4}
                    height={(x) => `calc(75svh - ${x.spacing(1)})`}
                >
                    <Grid
                        item
                        container
                        direction="column"
                        justifyContent="space-between"
                        height={'100%'}
                    >
                        <Grid item sx={styles.backgroundTender} mx={1} mt={1}>
                            <List dense sx={styles.listDetailContainer}>
                                <ListItem>
                                    <ListItemText
                                        primary={
                                            <Typography
                                                sx={styles.detailTextFont}
                                                fontWeight={'800px'}
                                            >
                                                {customer?.givenName ?? ''}{' '}
                                                {customer?.familyName ?? ''}
                                            </Typography>
                                        }
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemText
                                        primary={
                                            <Typography
                                                sx={styles.detailTextFont}
                                            >
                                                Point Balance:
                                            </Typography>
                                        }
                                    />
                                    <ListItemText
                                        primary={
                                            <Typography
                                                color="primary"
                                                align="right"
                                            >
                                                {customerPointBalance.toFixed(
                                                    2,
                                                )}
                                            </Typography>
                                        }
                                    />
                                </ListItem>
                                <Divider variant="middle" component="li" />
                                <ListItem>
                                    <ListItemText
                                        primary={
                                            <Typography
                                                sx={styles.detailTextFont}
                                            >
                                                Points to Redeem
                                            </Typography>
                                        }
                                    />
                                </ListItem>
                                <ListItem>
                                    <OWInput
                                        control={control}
                                        name="pointToRedeem"
                                        fullWidth
                                        //prevent douple input when type (input from calculation panel)
                                        onChangeCustomize={() => {}}
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemText
                                        primary={
                                            <Grid container spacing={1}>
                                                <Grid item container>
                                                    <Typography
                                                        sx={
                                                            styles.detailTextFont
                                                        }
                                                    >
                                                        Discount{' '}
                                                    </Typography>
                                                </Grid>
                                                <Grid item>
                                                    <Box display="flex">
                                                        <MonetaryFormat
                                                            sx={
                                                                styles.detailTextFont
                                                            }
                                                            value={
                                                                discount ?? 0
                                                            }
                                                        />
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        }
                                    />
                                </ListItem>
                            </List>
                        </Grid>
                        <Grid item mx={1} mb={1}>
                            <Box
                                paddingY={1}
                                sx={{ backgroundColor: 'background.default' }}
                            >
                                <Button
                                    size="large"
                                    sx={{ minHeight: 60 }}
                                    fullWidth
                                    color="primary"
                                    onClick={handleSubmit((v) =>
                                        onRedeemSubmit(
                                            v.pointToRedeem,
                                            v.discount,
                                            newTotal,
                                        ),
                                    )}
                                >
                                    Redeem
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    )
}
export default PaymentRedeemPoint
